/* @flow */

import * as React from 'react';
import { Routes, Route, useParams, useLocation } from 'react-router-dom';

import useReduxState from '../../hook/useReduxState';
import { getRoutes } from 'src/shared/app/base/route/registry/routeRegistry';
import {
  getRoutesFromState,
  setHttpStatusCode,
} from 'src/shared/app/base/route/util/routeUtils';

const HTTPStatusCodeElement = () => {
  const params = useParams();
  const location = useLocation();

  React.useEffect(() => {
    if (!location || location === '*') {
      setHttpStatusCode(params, 404);
    }
  }, [params]);

  return null;
};

const HTTPStatusCodeSwitch = (): React.Node => {
  const state = useReduxState();

  return (
    <Routes>
      {getRoutes().map((route) => {
        const [path] = getRoutesFromState(state, route);

        return (
          <Route path={path} element={<HTTPStatusCodeElement />} key={path} />
        );
      })}
    </Routes>
  );
};

export default React.memo<{}>(HTTPStatusCodeSwitch);
